var map = {
	"./subsidiariesProducts1.jpg": 42937,
	"./subsidiariesProducts2.jpg": 83206,
	"./subsidiariesProducts3.jpg": 81779,
	"./subsidiariesProducts4.jpg": 54757,
	"./subsidiariesProducts5.jpg": 52522,
	"./subsidiariesProducts6.jpg": 5200
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 47946;